module.exports = __webpack_public_path__ + "static/img/gray-close.e4a9908.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/gray-close.svg
// module id = jXdw
// module chunks = 55